<template>
  <div>
    <v-btn
      @click="getMessages()"
      style="top: 80px;"
      fixed
      fab
      top
      right
      color="green"
    >
    <v-icon color="white">refresh</v-icon>
    </v-btn>
    <v-container>
    <v-row>
      <!-- Példa: az "összes" üzenet (összefűzve) -->
      <v-col
        v-for="item in uzenetek"
        :key="item.id"
        cols="12"
      >
        <v-card>
          <v-card-text>
            <div v-html="item.text"></div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  data () {
    return {
      uzenetek: []
    }
  },
  methods: {
    getMessages: async function() {
      this.preloader = true
      this.uzenetek = {};
        await this.gettoken()
        this.$http.post('/kokeny/rendszeruzi', {
          token: this.token
        }).then((response) => {
          this.preloader = false
          this.uzenetek = response.data;
        }, (error) => {
          store.state.showing.preloader = false
          this.error_text = error.data
        })
      },
  },
  mounted() {
    this.getMessages()
  },
  computed: {
    ...mapFields([
  'showing.preloader',
  'auth.admin',
  'auth.fbuser',
  'auth.loginuser',
  'auth.username',
  'auth.placeid',
  'auth.prod',
  ]),
  }
};
</script>
